// extracted by mini-css-extract-plugin
export default {"default":"ChangeLanguageList__default__lPk6Z"};